var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 48,
    viewBox: "0 0 114 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 48
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_1_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.5376 0H24.4625C11.2076 0 0.462463 10.7452 0.462463 24C0.462463 37.2548 11.2076 48 24.4625 48H89.5376C102.792 48 113.538 37.2548 113.538 24C113.538 10.7452 102.792 0 89.5376 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_d_202_741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.4361 0H24.4625C11.2076 0 0.462463 10.7452 0.462463 24C0.462463 37.2548 11.2076 48 24.4625 48H89.4361C102.691 48 113.436 37.2548 113.436 24C113.436 10.7452 102.691 0 89.4361 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.09747 24C4.09747 12.6181 13.3243 3.3913 24.7062 3.3913H65.5076V44.6087H24.7062C13.3243 44.6087 4.09747 35.3819 4.09747 24Z",
    fill: "url(#paint0_linear_202_741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M86.6638 28.0863C85.5255 29.1379 83.9804 29.7389 82.3539 29.7389C80.7276 29.7389 79.1825 29.1379 78.044 28.0109C75.6045 25.7572 75.6045 22.151 78.044 19.8969L87.6398 10.9565L97.2354 19.8969C99.6749 22.151 99.6749 25.7572 97.2354 28.0109L97.154 28.0863C94.7959 30.2649 90.893 30.265 88.5345 28.0113C88.7624 31.5227 91.3329 34.3828 94.6702 34.9876V36H80.6083V34.9876C83.9713 34.3781 86.5557 31.4787 86.7488 27.9299L86.6638 28.0863Z",
    fill: "url(#paint1_linear_202_741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.1969 32.1012V19.6022H44.5676V15.8988H57.9924V19.6022H53.3632V32.1012H49.1969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.2532 32.1012V28.9764L38.66 19.4865H31.4847V15.8988H43.9837V19.0236L36.5769 28.5135H44.0994V32.1012H31.2532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.6403 32.1012V15.8988H20.964L26.2876 25.9674V15.8988H30.4539V32.1012H25.1303L19.8066 22.0326V32.1012H15.6403Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_741",
    x: -12.5375,
    y: -11,
    width: 138.974,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.952941 0 0 0 0 0.635294 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_741",
    x1: 5.51245,
    y1: 3.3913,
    x2: 71.8233,
    y2: 21.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38BDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_741",
    x1: 76.7407,
    y1: 10.9565,
    x2: 102.542,
    y2: 15.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38BDF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/authLogo.35c35a10858a031dc4e6c2609433c578.svg";
export { ForwardRef as ReactComponent };